import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Stack, Typography } from "@mui/material";
import { colors } from "../../theme/theme";

const SubscribedUsers = () => {
  // Define dummy data
  const columns = [
    {
      field: "id",
      headerName: "ID",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      flex: 0.2,
      display: "flex",
      alignItems: "center",
      renderCell: (params) => (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: colors.textColor,
            fontFamily: "Inter-Medium",
          }}
        >
          {params?.value}
        </Typography>
      ),
    },
    {
      field: "user",
      headerName: "Users",
      headerClassName: "super-app-theme--header",
      flex: 1,
      display: "flex",
      alignItems: "center",
      renderCell: (params) => (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          <img
            src={require("../../assets/images/avatar.png")}
            alt=""
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
            }}
          />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: colors.textColor,
              fontFamily: "Inter-Medium",
            }}
          >
            {params?.value}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "phone",
      headerName: "Phone",
      headerClassName: "super-app-theme--header",
      cellClassName: "custom-row-color",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      cellClassName: "custom-row-color",
      flex: 1,
    },
    {
      field: "plan",
      headerName: "Plans",
      headerClassName: "super-app-theme--header",
      cellClassName: "custom-row-color",
      flex: 1,
    },
    {
      field: "subscriptionDate",
      headerName: "Subscription Date",
      headerClassName: "super-app-theme--header",
      cellClassName: "custom-row-color",
      flex: 1,
    },
    {
      field: "paymentOption",
      headerName: "Payment Option",
      headerClassName: "super-app-theme--header",
      cellClassName: "custom-row-color",
      flex: 1,
    },
  ];

  const rows = [
    {
      id: 1,
      user: "John Doe",
      phone: "123-456-7890",
      email: "johndoe@example.com",
      plan: "Premium",
      subscriptionDate: "2025-01-01",
      paymentOption: "PayPal",
    },
    {
      id: 2,
      user: "Jane Smith",
      phone: "987-654-3210",
      email: "janesmith@example.com",
      plan: "Standard",
      subscriptionDate: "2025-01-05",
      paymentOption: "Credit Card",
    },
    {
      id: 3,
      user: "Alice Johnson",
      phone: "555-123-4567",
      email: "alicej@example.com",
      plan: "Basic",
      subscriptionDate: "2025-01-08",
      paymentOption: "Bank Transfer",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mt: 4,
        "& .super-app-theme--header": {
          backgroundColor: colors.bg,
          color: colors.textColor,
          fontFamily: "Inter-SemiBold",
        },
        "& .custom-row-color": {
          color: "#00000080", // Custom color for specific rows
        },
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        sx={{
          borderRadius: "0px",
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
          },
        }}
      />
    </Box>
  );
};

export default SubscribedUsers;
